// usePaginationHelpers.js

function normalizeEntries(result) {
  if (!result) return [];
  if (Array.isArray(result)) return result;
  if (Array.isArray(result.entries)) return result.entries;
  if (Array.isArray(result.data?.entries)) return result.data.entries;
  return [];
}

export function handleListClick(
  entryId,
  setCurrentIndex,
  setCurrentEntry,
  listEntries
) {
  const index = listEntries.findIndex((entry) => entry.id === entryId);
  if (index !== -1) {
    setCurrentIndex(index);
    setCurrentEntry(listEntries[index]);
  }
}

export function handleNextPage(listPageNo, setListPageNo, fetchPage) {
  const nextPage = listPageNo + 1;
  setListPageNo(nextPage);
  return fetchPage(nextPage, { resetIndex: false });
}

export function handlePrevPage(listPageNo, setListPageNo, fetchPage) {
  if (listPageNo > 0) {
    const prevPage = listPageNo - 1;
    setListPageNo(prevPage);
    return fetchPage(prevPage, { resetIndex: false });
  }
  return null;
}

export async function handleNextResult(
  currentIndex,
  setCurrentIndex,
  entries,
  listPageNo,
  setListPageNo,
  fetchPage
) {
  const list = Array.isArray(entries) ? entries : [];
  const isLastOnPage = currentIndex === list.length - 1;

  if (!isLastOnPage) {
    setCurrentIndex(currentIndex + 1);
    return null;
  }

  // Cross-page: WAIT for the next page fetch before moving index to 0
  const nextPage = listPageNo + 1;
  setListPageNo(nextPage);

  const result = await fetchPage(nextPage, { resetIndex: false });
  const nextEntries = normalizeEntries(result);

  // Guard: only move index if we actually got entries
  if (nextEntries.length > 0) {
    setCurrentIndex(0);
  }

  return result;
}

export async function handlePrevResult(
  currentIndex,
  setCurrentIndex,
  listPageNo,
  setListPageNo,
  fetchPage
) {
  const isFirstOnPage = currentIndex === 0;

  if (!isFirstOnPage) {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
    return null;
  }

  if (listPageNo > 0) {
    const prevPage = listPageNo - 1;
    setListPageNo(prevPage);

    const result = await fetchPage(prevPage, { resetIndex: false });
    const prevEntries = normalizeEntries(result);

    // last index of the newly loaded page
    const lastIdx = Math.max(0, prevEntries.length - 1);
    setCurrentIndex(lastIdx);

    return result;
  }

  return null;
}
